import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import './InkLevels.css';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { INK_LEVEL_THRESHOLD, INK_COLOR_MAP, LOCALSESSIONDATAKEYS, INK_REMAININIG_DAYS } from '../../../../../constants/AppConstants';
import warningCircleIcon from "../../../../../assets/images/warning-circle.svg";
import blueRightArrow from "../../../../../assets/images/blue-right-arrow.svg";
import truck from "../../../../../assets/images/truck.svg";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { CreateUserSupplyOrderInit, CreateUserSupplyOrderReset } from "../../../../../store/OrderEarly/CreateUserSupplyOrder/CreateUserSupplyOrderSlice";
import { GetSupplyOrderStatusReset, GetSupplyOrderStatusInit } from "../../../../../store/OrderEarly/GetSupplyOrderStatus/GetSupplyOrderStatusSlice";
import { routePath } from '../../../../../constants/Routes';
import { useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { getInkTranslation, getInkColorListTranslation } from '../../../../../constants/AppMethod';
import convertHtmlToReact from '@hedgedoc/html-to-react';
import { getLocalSessionData } from '../../../../../utils/Authentication/handleUserSession';
import { printerTypes } from '../../../../../constants/PrinterTypes';
import Loader from '../../../../../components/shared/loader/Loader';

const InkLevels = ({getDeviceStatusResponse, lowInkList, setLowInkList, isBPlusUpgradedEcoPro, setLowInkReplaced}) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation(["translation"]);
    const printerType = getLocalSessionData(LOCALSESSIONDATAKEYS.PRINTER_TYPE);
    const deviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);
    const [modalState, setModalState] = useState(false);

    const [failureModalstate, setFailureModalState] = useState(false);
    let [inkData, setInkData] = useState(prevState => prevState?.length ? prevState : []);

    const{
        orderSupplyStatusData
    } = useSelector(state => state.ROOTREDUCER_RTK.GetSupplyOrderStatus);

    const { orderSupplyData, success, error, loading } = useSelector(state => state.ROOTREDUCER_RTK.CreateUserSupplyOrder);
    let [earlyOrderInkColors, setEarlyOrderInkColors] = useState([]);
    const [orderPendingInkList, setOrderPendingInkList] = useState([]);

    useEffect( () => {        
        dispatch(GetSupplyOrderStatusReset());
        dispatch(CreateUserSupplyOrderReset());
        if(isBPlusUpgradedEcoPro){
            dispatch(GetSupplyOrderStatusInit());
        }
        // eslint-disable-next-line
    }, []);

    if( !inkData.length ){
        if( printerType === printerTypes.MONO_LASER){
            setInkData( [{ ink : 'Black', consumablesLeft : 0, daysLeft: '0', colorCode : INK_COLOR_MAP.BLACK, lowInk : false }] );
        }
        else{
            setInkData( [{ ink : 'Cyan', consumablesLeft : 0, daysLeft: '0', colorCode : INK_COLOR_MAP.CYAN, lowInk : false }, { ink : 'Magenta', consumablesLeft : 0, daysLeft: '0', colorCode : INK_COLOR_MAP.MAGENTA, lowInk : false }, { ink : 'Yellow', consumablesLeft : 0, daysLeft: '0', colorCode : INK_COLOR_MAP.YELLOW, lowInk : false }, { ink : 'Black', consumablesLeft : 0, daysLeft: '0', colorCode : INK_COLOR_MAP.BLACK, lowInk : false }]);
        }
    }

    useEffect( () =>{
        if(!success && error){
            failureToggleModal();
        }
        else if(orderSupplyData && success){
            toggleModal()
        }
        // eslint-disable-next-line
    }, [orderSupplyData, success, error] )

    useEffect( () => {
        if (getDeviceStatusResponse && getDeviceStatusResponse?.response) {
            setInkData( inkData.map((data) => {
                const consumableLeft = (getDeviceStatusResponse.response?.remainingConsumables !== null && Number(getDeviceStatusResponse.response?.remainingConsumables[data.ink.toLowerCase()]) ) || 0;
                const remDays = getDeviceStatusResponse.response?.remainingDays === null ? null : getDeviceStatusResponse.response?.remainingDays[data.ink.toLowerCase()];
                const lowInkLevel = INK_LEVEL_THRESHOLD[data.ink.toUpperCase()] || 0;
                if(!isBPlusUpgradedEcoPro){
                    if( consumableLeft <= lowInkLevel ){
                        data.lowInk = true;
                        setLowInkList( prevState => prevState?.indexOf( data.ink ) === -1 ? [...prevState, data.ink] : [...prevState] );
                        setLowInkReplaced( prevInkReplace => prevInkReplace.filter( inkColor => inkColor !== data.ink ) );
                    }
                    else if( consumableLeft > lowInkLevel && lowInkList.length ){
                        const lowInkIndex = lowInkList.indexOf( data.ink );
                        if( lowInkIndex !== -1 ){
                            data.lowInk = false;
                            setLowInkList( prevState => prevState.filter( inkColor => inkColor !== data.ink ) );
                            setLowInkReplaced( prevInkReplace => prevInkReplace?.indexOf( data.ink ) === -1 ? [...prevInkReplace, data.ink] : [...prevInkReplace] )
                        }
                    }
                }
                
                return {
                    ...data,
                    consumablesLeft : consumableLeft,
                    daysLeft: remDays
                };
            }));
            if(isBPlusUpgradedEcoPro && orderSupplyStatusData && orderSupplyStatusData?.deviceId === deviceId){
                let remainingDays= getDeviceStatusResponse.response?.remainingDays;
                if( remainingDays ){
                    setEarlyOrderInkColors([]);
                    setOrderPendingInkList([]);
                    let earlyOrderList = Object.keys(remainingDays).filter(key => ( remainingDays[key] <= INK_REMAININIG_DAYS && remainingDays[key] > 0 && orderSupplyStatusData[key]?.isEligibleForOrder && !orderSupplyStatusData[key]?.isShipped ) );
                    if (earlyOrderList.length > 0) {
                        const additionalKeys = Object.keys(remainingDays).filter(key => ( remainingDays[key] <= 50 && remainingDays[key] > 0 && orderSupplyStatusData[key]?.isEligibleForOrder && !orderSupplyStatusData[key]?.isShipped ));
                        setEarlyOrderInkColors([...new Set([...earlyOrderList, ...additionalKeys])]);
                    }
                    const pendingList = Object.keys(remainingDays).filter(key => ( !orderSupplyStatusData[key]?.isEligibleForOrder && orderSupplyStatusData[key]?.isShipped ) );
                    setOrderPendingInkList(pendingList);
                }
            }
        }
        // eslint-disable-next-line
    },[getDeviceStatusResponse, setLowInkList, isBPlusUpgradedEcoPro, orderSupplyStatusData]);

    const toggleModal = () => {
        setModalState(!modalState);
    }
    const failureToggleModal = () =>{
        setFailureModalState(!failureModalstate);
    }
    const orderEarly = () => {
        if(earlyOrderInkColors)
            dispatch(CreateUserSupplyOrderInit(earlyOrderInkColors))
    }

    const closeBtnFn = () => {
        success ? toggleModal() :failureToggleModal()
        window.location.reload();
    }

     const closeBtn = <svg xmlns="http://www.w3.org/2000/svg" onClick={() => closeBtnFn()} width="20" height="20" viewBox="0 0 14 13" fill="none">
        <line x1="1.41421" y1="1" x2="12" y2="11.5858" stroke="#262626" stroke-width="2" stroke-linecap="round"/>
        <line x1="2" y1="11.5858" x2="12.5858" y2="1" stroke="#262626" stroke-width="2" stroke-linecap="round"/>
        </svg>

    if(loading) return <Loader/>

    return(
        <>
            <div className='ink-levels' >
                { inkData && inkData?.map( data => {
                    return (
                    <div className={`ink-detail-block ${printerType === printerTypes.MONO_LASER ? "mono-laser-ink-detail" : ""}`} key={data.ink}>
                        <CircularProgressbarWithChildren
                            value={data.consumablesLeft}
                            strokeLinecap
                            counterClockwise={true}
                            styles={{
                                trail: {
                                    strokeWidth: 3,
                                },
                                path: {
                                    strokeWidth: 7,
                                    strokeLinecap: "butt",
                                    stroke: data.colorCode,
                                }
                            }}
                            >
                        </CircularProgressbarWithChildren>
                        <div className='ink-level-details'>
                            <div className='ink-level-text'>{getInkTranslation(data.ink)}</div>
                            <div className='ink-level-percentage'>{data.consumablesLeft}% </div>
                            {isBPlusUpgradedEcoPro && orderSupplyStatusData && orderSupplyStatusData[data.ink.toLowerCase()]?.isShipped 
                                ? <div className="shipped-message">
                                    <img src={truck} alt='truck' />
                                    <span> {t("INK_LEVELS.ORDER_SUPPLY_EARLY.ON_ITS_WAY")} </span>
                                </div>
                                : <div className= {( data.daysLeft !== null && data.daysLeft <= INK_REMAININIG_DAYS && data.daysLeft >= 0 ) ? 'ink-level-days-left low-ink-level' : 'ink-level-days-left' }>{data.daysLeft === null ? t("INK_LEVELS.ORDER_SUPPLY_EARLY.CARTRIDGE_DETECTION_ERROR")  : data.daysLeft === "-1.0" ? t("INK_LEVELS.ORDER_SUPPLY_EARLY.MORE_REMAINING"): data.daysLeft === "-2.0" ? t("INK_LEVELS.ORDER_SUPPLY_EARLY.ESTIMATING_INK_USAGE",{"inkColor": `${getInkTranslation(data.ink)}`}) : t("INK_LEVELS.ORDER_SUPPLY_EARLY.DAYS_OF_USAGE_LEFT", {"daysLeft":`${parseInt(data.daysLeft)}`})} </div>}
                        </div>
                    </div>) } 
                ) }
            </div>
            { isBPlusUpgradedEcoPro && earlyOrderInkColors.length > 0 && orderPendingInkList.length === 0 &&
            <div className="order-ink-early-warning">              
                <div className='early-order-msg'>
                    <img src= {warningCircleIcon} alt='warningCircleIcon' /> 
                    <span> {convertHtmlToReact(t("INK_LEVELS.ORDER_SUPPLY_EARLY.INK_WARNING", {"inkColors": `${getInkColorListTranslation(earlyOrderInkColors)}`}))} </span>
                </div>
                <div className="order-ink-button"
                    onClick={() => {
                        orderEarly();
                    }}>
                    {t("INK_LEVELS.ORDER_SUPPLY_EARLY.ORDER_EARLY_BUTTON")}
                    <img src= {blueRightArrow} alt='blueRightArrow' />
                </div>
            </div> 
            }

            { isBPlusUpgradedEcoPro && orderPendingInkList.length > 0 &&
            <div className="order-ink-early-warning">              
                <div className='early-order-msg'>
                    <img src= {warningCircleIcon} alt='warningCircleIcon' /> 
                    <span> {t("INK_LEVELS.ORDER_SUPPLY_EARLY.ORDER_PENDING_DELIVERY")} </span>
                </div>
            </div> 
            }

            {
                <div>
                    <Modal isOpen={modalState} toggle={() => toggleModal()} backdrop={true} size="sm" className="ink-ordered-popup" >
                        <ModalHeader close={closeBtn} ></ModalHeader>
                        <ModalBody>
                        {
                        <>
                            <div className='ink-modal-title'> {t("INK_LEVELS.ORDER_SUPPLY_EARLY.INK_ORDERED_POPUP.INK_ORDERED_TITLE")} </div>
                            <div>
                                {convertHtmlToReact(t("INK_LEVELS.ORDER_SUPPLY_EARLY.INK_ORDERED_POPUP.INK_ORDER_SUBMITTED", {"inkColors": `${getInkColorListTranslation(earlyOrderInkColors)}`}))}
                            </div> 
                            <div>
                                {t("INK_LEVELS.ORDER_SUPPLY_EARLY.INK_ORDERED_POPUP.INK_ORDER_SUBMIT_CONTENT")}
                            </div>
                        </>
                        }

                        </ModalBody>
                        <ModalFooter>
                            <Button className="outlineSecondary" onClick={() => history.push(routePath.ORDERS)}>
                                {t("INK_LEVELS.ORDER_SUPPLY_EARLY.INK_ORDERED_POPUP.VIEW_ORDERS")}
                            </Button>
                            <Button color="primary" onClick={() => window.location.reload()}>
                                {t("INK_LEVELS.ORDER_SUPPLY_EARLY.INK_ORDERED_POPUP.RETURN_TO_MY_DEVICE")}
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            }
            {
                <div>
                    <Modal isOpen={failureModalstate} toggle={ () => failureToggleModal() } backdrop={true}  size="sm" className="ink-order-failure-popup">
                        <ModalHeader close={closeBtn} >{t("INK_LEVELS.ORDER_SUPPLY_EARLY.INK_ORDERED_FAIL_POPUP.ERROR_TITLE")}</ModalHeader>
                        <ModalBody>
                        {
                            <div className='ink-modal-title'> {error} </div>
                        }
                        </ModalBody>
                    </Modal>
                </div>
            }
        </>
    )
}

export default InkLevels;